"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntelliscoreCard = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const score_breakdown_1 = __importDefault(require("../../components/score-breakdown"));
const StyledStandardCard = (0, styled_components_1.default)(base_react_components_1.StandardCard).withConfig({ displayName: "reports-StyledStandardCard", componentId: "reports-17cv6z4" }) `
  display: grid;
  grid-gap: 16px;
`;
const MeaningColorIndicator = styled_components_1.default.div.withConfig({ displayName: "reports-MeaningColorIndicator", componentId: "reports-januxk" }) `
  min-width: 6px;
  width: 6px;
  border-radius: 8px;
  background-color: ${({ bgColor }) => bgColor};
`;
const MeaningContent = styled_components_1.default.div.withConfig({ displayName: "reports-MeaningContent", componentId: "reports-1eqbh7e" }) `
  display: flex;
  flex-direction: column;
`;
const MeaningDefinition = styled_components_1.default.li.withConfig({ displayName: "reports-MeaningDefinition", componentId: "reports-1dv7e7a" }) `
  display: grid;
  grid-template-columns: 6px 1fr;
  grid-gap: 8px;
`;
const ScoreMeaning = styled_components_1.default.ul.withConfig({ displayName: "reports-ScoreMeaning", componentId: "reports-1e3uc4c" }) `
  padding: 0;
  display: grid;
  grid-gap: 16px;
`;
const ScoreHeader = styled_components_1.default.div.withConfig({ displayName: "reports-ScoreHeader", componentId: "reports-100judu" }) `
  display: grid;
  grid-template-columns: 24px 1fr;
  grid-gap: 16px;
`;
/**
 * The IntelliscoreCard component displays static educational content for Experian Intelliscore Plus℠ V2 score.
 *
 * @returns ReactElement
 */
const IntelliscoreCard = () => {
    const segmentBreakdown = [
        { label: '50%', color: base_react_components_1.theme.bubbleBlue400 },
        { label: '15%', color: base_react_components_1.theme.bubbleBlue200 },
        { label: '15%', color: base_react_components_1.theme.mermaidGreen400 },
        { label: '10%', color: base_react_components_1.theme.mermaidGreen300 },
        { label: '10%', color: base_react_components_1.theme.mermaidGreen100 },
    ];
    const legendBreakdown = [
        'Does the business have credit accounts that are past due?',
        'Does the business have public records or other legal claims against it?',
        'Is the business maxed out on its credit limits?',
        'On average how prompt does the business make its payments?',
        'Information such as time in business, size, and industry.',
    ];
    return (react_1.default.createElement(StyledStandardCard, { "data-testid": "score-explanation" },
        react_1.default.createElement(ScoreHeader, null,
            react_1.default.createElement(base_react_components_1.Icon, { name: "actions/circle-info" }),
            react_1.default.createElement(base_react_components_1.Header, { size: "lg" }, "How is a Experian Intelliscore Plus\u2120 V2 calculated?")),
        react_1.default.createElement(base_react_components_1.Copy, null, "The business credit score is what banks and suppliers use to decide whether or not to extend credit to your business. This score is calculated using the factors below."),
        react_1.default.createElement(score_breakdown_1.default, { segmentBreakdown: segmentBreakdown, legendBreakdown: legendBreakdown }),
        react_1.default.createElement(base_react_components_1.Header, { size: "lg" }, "What does my score mean?"),
        react_1.default.createElement(ScoreMeaning, null,
            react_1.default.createElement(MeaningDefinition, null,
                react_1.default.createElement(MeaningColorIndicator, { bgColor: base_react_components_1.theme.seaturtleGreen200 }),
                react_1.default.createElement(MeaningContent, null,
                    react_1.default.createElement(base_react_components_1.Copy, null,
                        react_1.default.createElement("strong", null, "51-100")),
                    react_1.default.createElement(base_react_components_1.Copy, null, "A score in this range is considered good. If your score is under 75, your business is in a slightly higher risk class, but you will likely still qualify for many business financing options."))),
            react_1.default.createElement(MeaningDefinition, null,
                react_1.default.createElement(MeaningColorIndicator, { bgColor: base_react_components_1.theme.flounderYellow200 }),
                react_1.default.createElement(MeaningContent, null,
                    react_1.default.createElement(base_react_components_1.Copy, null,
                        react_1.default.createElement("strong", null, "26-50")),
                    react_1.default.createElement(base_react_components_1.Copy, null, "A score in this range is considered medium risk and it may disqualify you from some business loan options or you may be given less-than-optimal terms like a higher interest rate or more collateral required."))),
            react_1.default.createElement(MeaningDefinition, null,
                react_1.default.createElement(MeaningColorIndicator, { bgColor: base_react_components_1.theme.sebastianRed200 }),
                react_1.default.createElement(MeaningContent, null,
                    react_1.default.createElement(base_react_components_1.Copy, null,
                        react_1.default.createElement("strong", null, "0-25")),
                    react_1.default.createElement(base_react_components_1.Copy, null, "A score in this range is considered high risk and may struggle to qualify for financing options. Improving your payment history can make a large impact on your Intelliscore, since that is the largest scoring factor, and may help you qualify for better financing options down the road."))),
            react_1.default.createElement(MeaningDefinition, null,
                react_1.default.createElement(MeaningColorIndicator, { bgColor: base_react_components_1.theme.neutral300 }),
                react_1.default.createElement(MeaningContent, null,
                    react_1.default.createElement(base_react_components_1.Copy, null,
                        react_1.default.createElement("strong", null, "0")),
                    react_1.default.createElement(base_react_components_1.Copy, null, "This business is in the process of filing for bankruptcy or has a bankruptcy filing already in the business\u2019s name."))))));
};
exports.IntelliscoreCard = IntelliscoreCard;
exports.default = (0, styled_components_1.default)(exports.IntelliscoreCard).withConfig({ componentId: "reports-1davz58" }) ``;
//# sourceMappingURL=index.js.map